module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"users":{"profile":{"resume":{"action":"Berufserfahrung hinzufügen","empty_state":"Fügen Sie Ihre Berufserfahrungen hinzu, um Besuchern Ihres Profils Ihre Kompetenz in Sachen Finanzen zu verdeutlichen.","title":"Berufserfahrung"}}}}}}}')
  delete Component.options._Ctor
}
